import { isEmptyString } from '@impuls-coach/util-is';
import { ValidationError } from 'components/hoc/withValidation';
import i18n from 'helper/i18n';
import { sanitizeInteger } from 'helper/sanitize';
import { VALIDATE_IS_NOT_ALLOWED } from 'helper/validator';

export const settings = {
	overallMin: 1,
	overallMax: 999,
};

export const codes = {
	empty: 1,
	invalidFormat: 2,
	exceedsOverall: 3,
};

const validRegex = /([0-9]+([0-9]+)?)/g;

export default function circumferenceValidatorFactory(inputValue: string): Promise<ValidationError | undefined> {
	return new Promise((resolve: Function, reject: Function) => {
		if (isEmptyString(inputValue)) {
			return resolve();
		}

		if (!inputValue.match(validRegex)) {
			return reject({
				type: VALIDATE_IS_NOT_ALLOWED,
				message: i18n('react.impulsCoach.components.cardDetail.tracking.validationWeist.invalidFormat'),
			});
		}

		const value = parseFloat(inputValue);

		if (value < settings.overallMin) {
			return reject({
				type: VALIDATE_IS_NOT_ALLOWED,
				message: i18n('react.impulsCoach.components.cardDetail.tracking.validationWeist.tooLow'),
			});
		}
		if (value > settings.overallMax) {
			return reject({
				type: VALIDATE_IS_NOT_ALLOWED,
				message: i18n('react.impulsCoach.components.cardDetail.tracking.validationWeist.tooHigh'),
			});
		}

		return resolve();
	});
}

export const sanitize = (value: string): string => {
	return sanitizeInteger(value);
};
